import AboutUs from '../client/pages/policy/pages/about-us'
import AffiliatePolicy from '../client/pages/policy/pages/affiliate-policy'
import BloggerProgram from '../client/pages/policy/pages/blogger-program'
import CouponCredits from '../client/pages/policy/pages/coupon-credits'
import ReturnPolicy from '../client/pages/policy/pages/return-policy'
import OutOfStock from '../client/pages/policy/pages/out-of-stock'
import WholesaleProgram from '../client/pages/policy/pages/wholesale-program'
import DropShipping from '../client/pages/policy/pages/drop-shipping'
import CopyRightNotice from '../client/pages/policy/pages/copyright-notice'
import PrivacySecurity from '../client/pages/policy/pages/privacy-security'
import TermsConditions from '../client/pages/policy/pages/terms-conditions'
import HowToPay from '../client/pages/policy/pages/how-to-pay'
import AfterPay from '../client/pages/policy/pages/after-pay'
import KlanraPolicy from '../client/pages/policy/pages/klanra-policy'
import ZipPolicy from '../client/pages/policy/pages/zip-policy'
import VipPolicy from '../client/pages/policy/pages/vip-policy'
import ClearPayPolicy from '../client/pages/policy/pages/clear-pay-policy'
import ShippingPolicy from '../client/pages/policy/pages/shipping-policy'
import ContactUs from '../client/pages/policy/pages/contact-us'
import OrderTracking from '../client/pages/policy/pages/order-tracking'
import BonusPoint from '../client/pages/policy/pages/bonus-point'
import WalletPolicy from '../client/pages/policy/pages/wallet-policy'
import EarlyBird from '../client/pages/policy/pages/early-bird'
import Faq from '../client/pages/policy/pages/faq'
import ShippingMore from '../client/pages/policy/pages/shipping-more'
import StagingInfo from '../client/pages/policy/pages/staging-info'

export default [
    {
        path: "/policy/about-us",
        exact: true,
        component: AboutUs,
        page: 'About Us',
        title: {
            en: 'About Us'
        },
        description: {
            en: 'About Us'
        }
    },
    {
        path: "/policy/affiliate-policy",
        exact: true,
        component: AffiliatePolicy,
        page: 'Affiliate Policy',
        title: {
            en: 'Affiliate Policy'
        },
        description: {
            en: 'Affiliate Policy'
        }
    },
    {
        path: "/policy/blogger-program",
        exact: true,
        component: BloggerProgram,
        page: 'Blogger Program',
        title: {
            en: 'Blogger Program'
        },
        description: {
            en: 'Blogger Program'
        }
    },
    {
        path: "/policy/coupon-credits",
        exact: true,
        component: CouponCredits,
        page: 'Coupon & Credits',
        title: {
            en: 'Coupon & Credits'
        },
        description: {
            en: 'Coupon & Credits'
        }
    },
    {
        path: "/policy/return-policy",
        exact: true,
        component: ReturnPolicy,
        page: 'Return Policy',
        title: {
            en: 'Return Policy'
        },
        description: {
            en: 'Return Policy'
        }
    },
    {
        path: "/policy/out-of-stock",
        exact: true,
        component: OutOfStock,
        page: 'Out Of Stock',
        title: {
            en: 'Out Of Stock'
        },
        description: {
            en: 'Out Of Stock'
        }
    },
    {
        path: "/policy/wholesale-program",
        exact: true,
        component: WholesaleProgram,
        page: 'wholesale program',
        title: {
            en: 'wholesale program'
        },
        description: {
            en: 'wholesale program'
        }
    },
    {
        path: "/policy/drop-shipping-policy",
        exact: true,
        component: DropShipping,
        page: 'Drop Shipping Policy',
        title: {
            en: 'Drop Shipping Policy'
        },
        description: {
            en: 'Drop Shipping Policy'
        }
    },
    {
        path: "/policy/copyright",
        exact: true,
        component: CopyRightNotice,
        page: 'Copyright Notice',
        title: {
            en: 'Copyright Notice'
        },
        description: {
            en: 'Copyright Notice'
        }
    },
    {
        path: "/policy/privacy-security-policy",
        exact: true,
        component: PrivacySecurity,
        page: 'Privacy Policy',
        title: {
            en: 'Privacy Policy'
        },
        description: {
            en: 'privacy statement: we will protetct customers\' privacy'
        }
    },
    {
        path: "/policy/terms-conditions-notice",
        exact: true,
        component: TermsConditions,
        page: 'Terms Of Services',
        title: {
            en: 'Terms Of Services'
        },
        description: {
            en: 'Terms Of Services'
        }
    },
    {
        path: "/policy/how-to-pay-policy",
        exact: true,
        component: HowToPay,
        page: 'Payment Method',
        title: {
            en: 'Payment Method'
        },
        description: {
            en: 'how-to-pay'
        }
    },
    {
        path: "/policy/after-pay-policy",
        exact: true,
        component: AfterPay,
        page: 'Afterpay FAQ',
        title: {
            en: 'Afterpay FAQ'
        },
        description: {
            en: 'Afterpay FAQ'
        }
    },
    {
        path: "/policy/klanra-policy",
        exact: true,
        component: KlanraPolicy,
        page: 'Klanra',
        title: {
            en: 'Klanra'
        },
        description: {
            en: 'Klanra Policy'
        }
    },
    {
        path: "/policy/zip-policy",
        exact: true,
        component: ZipPolicy,
        page: 'ZIP',
        title: {
            en: 'ZIP'
        },
        description: {
            en: 'ZIP Policy'
        }
    },
    {
        path: "/policy/clearpay-policy",
        exact: true,
        component: ClearPayPolicy,
        page: 'Clear Pay',
        title: {
            en: 'Clear Pay'
        },
        description: {
            en: 'Clear Pay Policy'
        }
    },
    {
        path: "/policy/vip-policy",
        exact: true,
        component: VipPolicy,
        page: 'VIP Rules',
        title: {
            en: 'VIP Rules'
        },
        description: {
            en: 'VIP Policy'
        }
    },
    {
        path: "/policy/shipping-policy",
        exact: true,
        component: ShippingPolicy,
        page: 'Shipping Policy',
        title: {
            en: 'Shipping Policy',
            pt: 'Pol\u00edtica de frete'
        },
        description: {
            en: 'Shipping Policy',
            pt: 'Pol\u00edtica de frete'
        }
    },
    {
        path: "/policy/shipping-more",
        exact: true,
        component: ShippingMore,
        page: 'Shipping Policy',
        title: {
            en: 'Shipping Policy'
        },
        description: {
            en: 'Shipping Policy'
        }
    },
    {
        path: "/policy/contact-us",
        exact: true,
        component: ContactUs,
        page: 'Contact',
        title: {
            en: 'Contact'
        },
        description: {
            en: 'Contact'
        }
    },
    {
        path: "/policy/order-tracking",
        exact: true,
        component: OrderTracking,
        page: 'Order Tracking',
        title: {
            en: 'Order Tracking'
        },
        description: {
            en: 'Order Tracking'
        }
    },
    {
        path: "/policy/bonus-point",
        exact: true,
        component: BonusPoint,
        page: 'Bonus Point',
        title: {
            en: 'Bonus Point'
        },
        description: {
            en: 'Bonus Point'
        }
    },
    {
        path: "/policy/faq",
        exact: true,
        component: Faq,
        page: 'FAQ',
        title: {
            en: 'FAQ'
        },
        description: {
            en: 'FAQ'
        }
    },
    {
        path: "/policy/wallet-policy",
        exact: true,
        component: WalletPolicy,
        page: 'Wallet Policy',
        title: {
            en: 'Wallet Policy'
        },
        description: {
            en: 'Wallet Policy'
        }
    },
    {
        path: "/policy/early-bird",
        exact: true,
        component: EarlyBird,
        page: 'About Early Bird',
        title: {
            en: 'About Early Bird'
        },
        description: {
            en: 'About Early Bird'
        }
    },
    {
        path: "/policy/staging",
        exact: true,
        component: StagingInfo,
        page: 'Staging Info',
        title: {
            en: 'Staging Info'
        },
        description: {
            en: 'Staging Info'
        }
    },
]